<template>
  <div id="loginOTP">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <v-img
            src="../assets/img/logo-tl.png"
            width="80"
            class="mt-8 tl_logo"
            style="margin: auto"
          ></v-img>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="3" class="login_slim">
          <v-card elevation="10" class="login_card">
            <v-card-text class="login">
              <v-alert v-if="!!message" type="error"> {{ message }}</v-alert>
              <v-form id="login-form" @submit.prevent="submitLogin" autocomplete="off">
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="8" md="8">
                    <h1 align="center" class="login_prihlasenie">Prihlásenie SMS kódom</h1>
                  </v-col>
                </v-row>

                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="8" md="8">
                    <form-component title="">
                      <v-text-field
                        v-model="password"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.password]"
                        :type="showPass ? 'text' : 'password'"
                        :label="'SMS kód'"
                        class="dynamic-input-control"
                        outlined
                        @click:append="showPass = !showPass"
                      ></v-text-field>
                    </form-component>
                  </v-col>
                </v-row>
              </v-form>
              <v-row align="center" justify="center" class="">
                <v-col cols="12" sm="8" md="8">
                  <v-btn type="submit" color="primary" form="login-form" depressed
                    >Prihlásiť sa</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="">
        <v-col align="center" class="v-copyright" cols="12" sm="8" md="8">
          V spolupráci s <b>NCC a.s.</b> © {{ year }}
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FormComponent from '../components/FormComponent.vue';
import axios from 'axios';
import protectedAxios from '../auth/axios.js';
import TextBox from '../components/basic/TextBox.vue';
import CheckBox from '../components/basic/CheckBox.vue';
import { mapMutations } from 'vuex';

import moment from 'moment';

export default {
  components: {
    FormComponent,
    TextBox,
    CheckBox,
  },
  data() {
    return {
      showPass: false,
      guid: '',
      password: '',
      message: '',
      messageOk: '',
      rules: {
        password: value => !!value || 'Zadajte prosím SMS kód!',
      },
      year: moment().year(),
    };
  },
  methods: {
    ...mapMutations(['setOtp']),
    submitLogin() {
      if (!this.password || this.password.length < 6) {
        return;
      }
      this.guid = this.$route.query.id;
      protectedAxios
        .post('/login/checkotpguidpin', {
          guid: this.guid,
          pin: this.password,
          host: window.location.hostname,
        })
        .then(response => {
          if (response.data.resultmessage == '') {
            this.setOtp({ guid: this.guid, pin: this.password });
            this.$router.push('uploadop');
            //return?
          }
          if (response.data.resultmessage != '') {
            this.message = response.data.resultmessage;
          }
        })
        .catch(error => {
          this.message = 'Nastala chyba pri prihlasovaní. Zlyhalo pripojenie na server.';
          console.error(error);
        });
    },
  },
};
</script>
<style lang="sass"></style>
